import Checkbox from "../../common/Checkbox";
import { useAppSelector } from "../../../utils/hooks/store";
import { useUpdateSearch } from "../../../utils/hooks/partSearch";
import { PartSearchSort } from "../../../reducers/componentSearch";
import { SearchOptionsContainer } from "./PartsTableStyles";

/**
 * Sorting by in stock quantity is only possible for in stock (internal)
 * searches, so turning sorting on also turns "in stock parts only" on, and
 * turning "in stock parts only" off also turns sorting off.
 */
export default function SearchOptions() {
  const { loading, searchParameters } = useAppSelector(
    (state) => state.componentSearch,
  );
  const updateSearch = useUpdateSearch();

  const inStockOnly = searchParameters?.inStockOnly || false;
  const sortByInStockQuantity =
    searchParameters?.sort === PartSearchSort.PHYSICAL_INVENTORY_LEVEL;

  const toggleInStockOnly = () => {
    updateSearch({
      updateSearchParameters: {
        inStockOnly: !inStockOnly,
        page: 1,
        ...(inStockOnly ? { sort: null } : {}),
      },
    });
  };

  const toggleSortByInStockQuantity = () => {
    updateSearch({
      updateSearchParameters: {
        sort: sortByInStockQuantity
          ? null
          : PartSearchSort.PHYSICAL_INVENTORY_LEVEL,
        ...(sortByInStockQuantity ? {} : { inStockOnly: true }),
        page: 1,
      },
    });
  };

  return (
    <SearchOptionsContainer>
      <Checkbox
        checked={inStockOnly}
        onChange={toggleInStockOnly}
        label="In stock parts only"
        disabled={loading}
      />
      <Checkbox
        checked={sortByInStockQuantity}
        onChange={toggleSortByInStockQuantity}
        label="Sort by in stock quantity"
        disabled={loading}
      />
    </SearchOptionsContainer>
  );
}
